import { CARD_GRADIENTS } from '../../../assets/constants/cardStyles';
import './TransactionCardIdentity.css';

const FALLBACK_CARD_GRADIENT = 'linear-gradient(135deg, #8d929d 0%, #c7cad1 100%)';

function TransactionCardIdentity({ transaction, variant = 'badge', showName = false }) {
  const cardName = String(transaction?.cardName || '').trim();
  const last4 = String(transaction?.cardLast4 || '').trim();

  if (!last4) {
    return null;
  }

  const gradient = CARD_GRADIENTS[transaction?.cardStyle] || FALLBACK_CARD_GRADIENT;
  const className = [
    'transaction-card-identity',
    `transaction-card-identity--${variant}`,
  ].join(' ');

  return (
    <span className={className}>
      <span
        className="transaction-card-identity__card"
        style={{ '--transaction-card-gradient': gradient }}
      >
        <span className="transaction-card-identity__last4">{last4}</span>
      </span>
      {showName && cardName ? (
        <span className="transaction-card-identity__name">{cardName}</span>
      ) : null}
    </span>
  );
}

export default TransactionCardIdentity;
